// Small colour helpers for #rrggbb values.

// Blend a colour toward black (amount < 0) or white (amount > 0), e.g. -0.3 = 30% darker.
export const shade = (hex, amount) => {
  const target = amount < 0 ? 0 : 255;
  const t = Math.abs(amount);
  return '#' + [1, 3, 5]
    .map(i => parseInt(hex.slice(i, i + 2), 16))
    .map(v => Math.round(v + (target - v) * t).toString(16).padStart(2, '0'))
    .join('');
};

// Append an alpha channel: withAlpha('#6d4aff', 0.2) → '#6d4aff33'.
export const withAlpha = (hex, a) => hex + Math.round(a * 255).toString(16).padStart(2, '0');
